'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Slot, Slottable } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef, version } from 'react';
import { Spinner } from '../spinner/spinner.js';

/**
 * Button used for interaction
 *
 * @example
 * <Button>Click me</Button>
 */
const Button = forwardRef(function Button({ asChild, className, children, icon = false, loading = false, variant = 'primary', popoverTarget, popovertarget, ...rest }, ref) {
    const Component = asChild ? Slot : 'button';
    const popoverVal = popoverTarget ?? popovertarget;
    const popoverKey = version.startsWith('19')
        ? 'popoverTarget'
        : 'popovertarget';
    // Fallbacks to undefined to prevent rendering attribute="false"
    return (jsxs(Component, { suppressHydrationWarning // Might get augmented through designsystemet-web with aria-haspopup etc.
        : true, "aria-busy": Boolean(loading) || undefined, "aria-disabled": Boolean(loading) || undefined, className: cl('ds-button', className), "data-icon": icon || undefined, "data-variant": variant, ref: ref, 
        /* don't set type when we use `asChild` */
        type: asChild ? undefined : 'button', [popoverKey]: popoverVal, ...rest, children: [loading === true ? (jsx(Spinner, { "aria-hidden": 'true' })) : (loading // Allow custom loading spinner
            ), jsx(Slottable, { children: icon && loading ? null : children })] }));
});

export { Button };
